import type { LeaveRequest } from "@spork/s4p-server-sdk";

import { getLeaveRequestPriority } from "@/features/home/leaveRequestStatus";

/**
 * Sort leave requests so actionable items appear first, then by start date (newest first).
 */
export function sortLeaveRequests(requests: LeaveRequest[]): LeaveRequest[] {
  return [...requests].sort((left, right) => {
    const priorityDiff =
      getLeaveRequestPriority(left.status) - getLeaveRequestPriority(right.status);

    if (priorityDiff !== 0) {
      return priorityDiff;
    }

    const dateDiff = right.date_from.localeCompare(left.date_from);

    if (dateDiff !== 0) {
      return dateDiff;
    }

    return right.id - left.id;
  });
}
